import { BookOpen, Download, X } from "lucide-react";
import { HELP_CONTENT } from "../helpContent";

// Manual de usuario en pantalla, según el rol de quien está dentro
export default function HelpModal({ role, onClose }) {
  const sections = HELP_CONTENT[role] || HELP_CONTENT.admin;
  const roleLabel = { superadmin: "Superadministrador", admin: "Administrador", viewer: "Consulta", vendedor: "Vendedor", entrega: "Entrega", partner: "Colaborador" }[role] || role;

  const downloadPdf = async () => {
    const { jsPDF } = await import("jspdf");
    const logoData = await fetch("/logo-topacio.jpg")
      .then((r) => r.blob())
      .then((blob) => new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      }))
      .catch(() => null);
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 46;
    const maxW = pageW - margin * 2;
    let y = 0;

    const footer = () => {
      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text("Rent a Moto Topacio · rent@rentamototenerife.es", margin, pageH - 26);
      doc.text(`${doc.internal.getNumberOfPages()}`, pageW - margin, pageH - 26, { align: "right" });
    };
    const pageBreakIfNeeded = (needed = 42) => {
      if (y + needed > pageH - 64) {
        footer();
        doc.addPage();
        y = 52;
      }
    };

    doc.setFillColor(255, 204, 0);
    doc.rect(0, 0, pageW, 86, "F");
    doc.setDrawColor(17, 17, 17);
    doc.setLineWidth(2);
    doc.rect(14, 14, pageW - 28, 58);
    if (logoData) {
      doc.addImage(logoData, "JPEG", pageW - margin - 50, 21, 44, 44, undefined, "FAST");
    }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(19);
    doc.setTextColor(17, 17, 17);
    doc.text("RENT A MOTO TOPACIO", margin, 40);
    doc.setFontSize(11);
    doc.text(`Manual de usuario · ${roleLabel}`, margin, 62);
    y = 116;

    sections.forEach((s) => {
      pageBreakIfNeeded(70);
      doc.setFontSize(13);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(227, 30, 36);
      doc.text(s.title, margin, y);
      y += 18;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(45, 45, 45);
      s.body.forEach((line) => {
        const wrapped = doc.splitTextToSize(`• ${line}`, maxW);
        pageBreakIfNeeded(wrapped.length * 13 + 6);
        doc.text(wrapped, margin + 6, y);
        y += wrapped.length * 13 + 5;
      });
      y += 10;
    });
    footer();
    doc.save(`manual-topacio-${role}.pdf`);
  };

  return (
    <div className="fixed inset-0 z-[99] flex items-stretch sm:items-center justify-center p-0 sm:p-4" data-testid="help-modal">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative card-brutal !rounded-none sm:!rounded-xl w-full sm:max-w-2xl h-full sm:h-auto sm:max-h-[85vh] overflow-y-auto" data-lenis-prevent>
        <div className="flex items-center justify-between px-6 py-4 border-b-2 border-topacio-ink sticky top-0 bg-white z-10 gap-3">
          <h3 className="font-display font-bold text-topacio-ink flex items-center gap-2">
            <BookOpen className="w-5 h-5 text-topacio-red" /> Manual de usuario · {roleLabel}
          </h3>
          <div className="flex items-center gap-2">
            <button data-testid="help-download-pdf" onClick={downloadPdf}
              className="flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-wider border-2 border-topacio-ink rounded-lg bg-brand px-2.5 py-1.5 text-topacio-ink hover:-translate-y-0.5 transition-transform">
              <Download className="w-3.5 h-3.5" /> PDF
            </button>
            <button data-testid="help-modal-close" onClick={onClose} className="text-topacio-faded hover:text-topacio-ink p-1"><X className="w-5 h-5" /></button>
          </div>
        </div>
        <div className="p-6 space-y-6">
          {sections.map((s) => (
            <section key={s.title}>
              <h4 className="font-display font-bold text-topacio-ink text-sm mb-2 flex items-center gap-2">
                <span className="w-2 h-2 bg-brand border border-topacio-ink rounded-sm inline-block" /> {s.title}
              </h4>
              <ul className="space-y-1.5">
                {s.body.map((line, i) => (
                  <li key={i} className="text-sm text-topacio-faded font-semibold leading-relaxed pl-4 relative">
                    <span className="absolute left-0 top-[9px] w-1.5 h-1.5 bg-topacio-red rounded-full" />
                    {line}
                  </li>
                ))}
              </ul>
            </section>
          ))}
          <p className="text-[10px] text-center text-zinc-400 font-bold uppercase tracking-wider pt-2 border-t border-zinc-100">
            Rent a Moto Topacio · soporte: rent@rentamototenerife.es
          </p>
        </div>
      </div>
    </div>
  );
}
